export const iconFontAwesomeDisasterCrisisPersonWalkingDashedLineArrowRight = (
	<i className="fa-solid fa-person-walking-dashed-line-arrow-right"></i>
);
